<script setup>
import { RouterLink } from "vue-router";
import { StealieText } from "@get-overalls/fe-stealie";
import { useNavigation } from "@/composables/useNavigation";
import { PlusIcon } from "@heroicons/vue/24/outline";
import { useRequestSurveyStore } from "@/stores/requestSurvey";

const { navigationItems } = useNavigation();
const requestSurveyStore = useRequestSurveyStore();
</script>

<template>
  <nav
    class="sticky bottom-0 z-20 flex w-screen shrink-0 items-stretch bg-white shadow-[0px_-4px_10px_0px_rgba(0,0,0,.05)] lg:hidden"
    data-sr-unmask
  >
    <template v-for="(navItem, index) in navigationItems" :key="navItem.route">
      <div
        v-if="index === Math.floor(navigationItems.length / 2)"
        class="flex items-center justify-center"
      >
        <button
          class="mx-4 flex h-16 w-16 items-center justify-center rounded-full bg-brand-primary-teal-400 text-white"
          @click="requestSurveyStore.openCategoryDrawer('explore')"
        >
          <PlusIcon class="size-6 stroke-2" aria-hidden="true" />
          <span class="sr-only">Create a request</span>
        </button>
      </div>
      <RouterLink
        :to="navItem.route"
        class="group flex flex-1 flex-col items-center justify-center gap-y-2 text-brand-gray-600"
        exact-active-class="bg-brand-primary-teal-highlight text-black"
      >
        <component
          :is="navItem.icon"
          class="size-6 text-brand-primary-teal-400 group-[.router-link-active]:text-black"
        />
        <StealieText size="sm" bold>{{ navItem.label }}</StealieText>
      </RouterLink>
    </template>
  </nav>
</template>
